import { observable, action, computed } from 'mobx';
import axios from '../lib/axios';

class AskStore {
  @observable sectionId;
  @observable products = [];
  @observable errorMessage;
  @observable status = 'waiting';
  @observable loading = false;

  @action send(productId, questionText, callback) {
    this.errorMessage = '';
    this.status = 'sending';

    axios.post(`/questions`, {
      section_id: this.sectionId,
      product_id: productId,
      question: questionText
    })
    .then((result) => {
      this.status = 'success';
      setTimeout(function(){
        if (callback)
          callback();
        this.status = 'waiting';
      }.bind(this), 3000);
    })
    .catch((error) => {
      this.errorMessage = 'Dados inválidos, verifique.'
      this.status = 'error';
    });
  }

  @action setSectionId(sectionId) {
    this.sectionId = sectionId;
  }

  @action fetchData() {
    this.products = [];
    if (this.sectionId != 0) {
      this.loading = true;
      axios.get(`/sections/${this.sectionId}`)
        .then((result) => {
          this.loading = false;
          this.products = result.data.products;
        })
        .catch((error) => {
          this.loading = false;
        });
    }
  }

  @computed get isSending() {
    return this.status === 'sending';
  }

  @computed get isSuccess() {
    return this.status === 'success';
  }
}

export default new AskStore();



// WEBPACK FOOTER //
// ./src/stores/AskStore.js